module.exports = __webpack_public_path__ + "img/MANUTENCAO-thumb.684303e9.png";